require('flexslider');

export default class Slider {

    constructor() {

    	var $this = this;

		$(window).on('load', function() {

			$this.sliderWithCustomDirectionNav();

		});

    }

    sliderWithCustomDirectionNav() {

		$('.flexslider-custom-nav').flexslider({
			slideshow: false,
			controlNav: false,
			slideshow: false,
            smoothHeight: true,
		});

		$( "body" ).on( "click", ".flexslider-custom-nav .js-next", function() {
			$(this).closest('.flexslider').find('.flex-next').click();
		});

		$( "body" ).on( "click", ".flexslider-custom-nav .js-prev", function() {
			$(this).closest('.flexslider').find('.flex-prev').click();
		});

    }
    
}